import { Alert, Card, Skeleton } from "antd";
import { useState } from "react";
import useAggregatedSalesData from "../../hooks/useAggregatedSalesData";
import useDailyOccupationData from "../../hooks/useDailyOccupationData";
import RevenueChart from "./RevenueChart";
import RevenuePeriodSelector from "./RevenuePeriodSelector";

export default function RevenueCardChart({
  selectedDateRange,
  selectedZones,
  selectedCollections,
  selectedStores,
}) {
  const [selectedPeriod, setSelectedPeriod] = useState("day");

  const { data: dailyOccupationData, isLoading: isLoadingDailyOccupationData } =
    useDailyOccupationData(
      selectedDateRange[0],
      selectedDateRange[1],
      selectedPeriod,
      selectedZones,
      selectedStores
    );

  const {
    data: aggregatedSalesData,
    isLoading: isLoadingAggregatedSalesData,
    error: aggregatedSalesError,
  } = useAggregatedSalesData(
    selectedDateRange[0],
    selectedDateRange[1],
    selectedPeriod,
    selectedCollections.join(",")
  );

  return (
    <Card
      title="Análise Gráfica do Faturamento"
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "#d0d6e2",
        },
      }}>
      <RevenuePeriodSelector
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
      />

      <div style={{ minHeight: "400px" }}>
        {isLoadingAggregatedSalesData || isLoadingDailyOccupationData ? (
          <Skeleton active style={{ height: "100%" }} />
        ) : aggregatedSalesError ? (
          <Alert
            message="Erro ao carregar dados"
            description="Não foi possível carregar os dados de faturamento. Por favor, tente novamente mais tarde."
            type="error"
            showIcon
          />
        ) : (
          <RevenueChart
            labels={aggregatedSalesData?.labels}
            faturamento_data={aggregatedSalesData?.data}
            permanenceData={dailyOccupationData}
            style={{ height: "100%" }}
          />
        )}
      </div>
    </Card>
  );
}
